export const PHYSICIAN_MENU = [
  {
    id: "personalInfo",
    title: "Personal Details",
    path: "/step1",
  },
  {
    id: "practiceDetails",
    title: "Practice Details",
    path: "/step2",
  },
  {
    id: "documents",
    title: "Documents",
    path: "/step3",
  },
  {
    id: "uploadSignature",
    title: "Upload Signature",
    path: "/uplaodsignature",
  },
  {
    id: "bankDetails",
    title: "Bank Details",
    path: "/step4",
  },
  {
    id: "dosespot",
    title: "Dosespot Profile",
    path: "/dosespot",
  },
  {
    id: "personaliseExperience",
    title: "Personalise Experience",
    path: "/step5",
  },
  {
    id: "purchaseSubscription",
    title: "Purchase Subscription",
    path: "/step6",
  },
];

export const PATIENT_MENU = [
  {
    id: "patientPersonalDetails",
    title: "Personal Details",
    path: "/step1",
  },
  {
    id: "patientContactDetails",
    title: "Contact Details",
    path: "/contact",
  },
  {
    id: "patientDosespotDetail",
    title: "e-Prescription Profile",
    path: "/dosespotPatient",
  },
  {
    id: "patientMedicalRecord",
    title: "Medical Records",
    path: "/step2",
  },
];
